const DB_NAME = 'harumi-storage'
const DB_VERSION = 1
let db = null
let dbInitPromise = null

async function getDb() {
  return new Promise((resolve, reject) => {
    let request = window.indexedDB.open(DB_NAME, DB_VERSION)

    request.onerror = e => {
      console.log('Error opening db', e)
      reject(e)
    }

    request.onsuccess = e => {
      resolve(e.target.result)
    }

    request.onupgradeneeded = e => {
      let db = e.target.result
      db.createObjectStore('data', { autoIncrement: true })
    }
  })
}

// Initialize DB connection
function initDb() {
  if (!dbInitPromise) {
    dbInitPromise = getDb().then(result => {
      db = result
      return db
    })
  }
  return dbInitPromise
}

async function getData(key, type = 'data') {
  await initDb() // Ensure DB is initialized
  return new Promise(resolve => {
    if (db) {
      let trans = db.transaction([type], 'readonly')
      let store = trans.objectStore(type)
      let request = key ? store.get(key) : store.getAll()
      let data = null
      
      request.onsuccess = (event) => {
        data = event.target.result
      }

      request.onerror = e => {
        resolve(false)
      }

      trans.oncomplete = e => {
        resolve(data || false)
      }
    } else {
      resolve(null)
    }
  })
}

async function clearItem() {
  await initDb() // Ensure DB is initialized
  return new Promise(resolve => {
    if (db) {
      let trans = db.transaction(['data'], 'readwrite')
      let store = trans.objectStore('data')
      resolve(store.clear())
    } else {
      resolve(false)
    }
  })
}

export default {
  setItem: async (key, value) => {
    if (key && db) {
      let trans = await db.transaction(['data'], 'readwrite')
      let store = await trans.objectStore('data')
      await store.put(value, key)
    }
  },
  getItem: async (key) => {
    let data = await getData(key)
    return data
  },
  removeItem: async (key) => {
    if (key) {
      let trans = await db.transaction(['data'], 'readwrite')
      let store = await trans.objectStore('data')
      await store.delete(key)
    }
  },
  clear: () => {
    clearItem()
  },
  getListData: async () => {
    return new Promise(resolve => {
      if (db) {
        let trans = db.transaction(['data'], 'readwrite')
        let store = trans.objectStore('data')
        let request = store.openCursor()
        let data = {}
        request.onerror = function (event) {
          resolve({})
        }

        request.onsuccess = function (event) {
          let cursor = event.target.result
          if (cursor) {
            let key = cursor.primaryKey
            let value = cursor.value
            data[key] = value
            cursor.continue()
          } else {
            resolve(data)
          }
        }
      } else {
        resolve({})
      }
    })
  },
}
